/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove room" |
*
* @param {Rooms_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_remove = /** @type {((inputs?: Rooms_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer la salle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar sala")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover sala")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi sala")
	return /** @type {LocalizedString} */ ("Remove room")
});